/* eslint-disable react/prop-types */
import React from 'react';
import styles from './SubNav.less';

/**
 * SubNav —— 二级导航（分组 Segmented，一行）
 * ==================================================================
 * 形态对齐原型 `docs/prototypes/merchant-profile-v2-preview.html` 的 `.seg`：
 * 浅灰底分组 + **选中项白底卡片 + 细阴影**（28px 高、13px 字）。
 *
 * 2026-09-17 修正（用户指出与原型不一致）：
 *   此前这里实现成「下划线文字 tab + 底部 3px 蓝条 + 分隔线」（53px 高、14px 字），
 *   而方案 §4.1 与原型规定二级用 **Segmented**（一级才用下划线 tab）→ 已改。
 *   同时删掉「三级胶囊 chips」分支：三级导航在 P1 全部收敛（会员经营改锚点、
 *   商家档案改同层 Tabs）后已无调用方，属死代码。
 *
 * 结构规则：一屏只允许「一级 tab + 一条二级导航」，二级超出时横向滚动不换行。
 *
 * @param groups        分组数组：value / label（平级、无第三层）
 * @param groupValue    当前二级
 * @param onGroupChange 回调：入参为二级 value
 */
const SubNav = (props) => {
  const { groups = [], groupValue, onGroupChange, className } = props;

  return (
    <div className={`${styles.row} ${className || ''}`} data-pg-sticky-subnav>
      <div className={styles.seg} role="tablist">
        {groups.map((g) => {
          const active = g.value === groupValue;
          return (
            <button
              key={g.value}
              type="button"
              role="tab"
              aria-selected={active}
              className={`${styles.tab} ${active ? styles.tabActive : ''}`}
              onClick={() => onGroupChange && onGroupChange(g.value)}
            >
              {g.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default SubNav;
